import * as React from "react";

function IconArrowRotaryFirstRight({
  size = 24,
  color = "currentColor",
  stroke = 2,
  ...props
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-arrow-rotary-first-right" width={size} height={size} viewBox="0 0 24 24" strokeWidth={stroke} stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}><desc>{"Download more icon variants from https://tabler-icons.io/i/arrow-rotary-first-right"}</desc><path stroke="none" d="M0 0h24v24H0z" fill="none" /><circle cx={8} cy={7} r={3} /><path d="M8 10v10" /><path d="M10.5 9.5l8.5 8.5" /><path d="M14 18h5v-5" /></svg>;
}

export default IconArrowRotaryFirstRight;